'use client'

import './SubmitButton.scss'

import { useTranslations } from 'next-intl'
import { useFormStatus } from 'react-dom'

const SubmitButton = () => {
  const t = useTranslations('FormFields')
  const { pending } = useFormStatus()

  return (
    <button className="submit-button" disabled={pending} type="submit">
      {t('formButton')}
    </button>
  )
}

export default SubmitButton
